import BidGroupVendorSpecQuoteItem from "../BidGroupVendorSpecQuoteItem";

describe("BidGroupVendorSpecQuoteItem Model", () => {
  test("belongsTo relations", () => {
    expect(
      BidGroupVendorSpecQuoteItem.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
